
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","opacity":".4","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.325 18.958c-.167 0-.3-.033-.4-.075-.333-.125-.9-.533-.9-1.825v-5.375h-1.95c-1.117 0-1.517-.525-1.658-.833-.142-.317-.267-.958.466-1.8l6.309-7.167c.85-.966 1.541-.9 1.875-.775.333.125.9.534.9 1.825v5.375h1.95c1.117 0 1.516.525 1.658.834.142.316.267.958-.466 1.8L9.8 18.108c-.592.675-1.108.85-1.475.85zM11.61 2.283c-.025.034-.2.117-.476.434L4.825 9.883c-.233.267-.267.434-.267.467.017.008.167.092.517.092H7.65a.63.63 0 01.625.625v6c0 .416.075.6.108.65.025-.034.2-.117.475-.434l6.309-7.166c.233-.267.267-.434.267-.467-.017-.008-.167-.092-.517-.092h-2.575a.63.63 0 01-.625-.625v-6c.008-.416-.075-.591-.109-.65z"}})])
          )
        }
      }
    